/* eslint-disable react/no-array-index-key */
import React, { lazy, Suspense, Fragment } from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';
import MainLayout from 'src/layouts/MainLayout';
import LoadingScreen from 'src/components/LoadingScreen';
import AuthGuard from 'src/components/AuthGuard';
import GuestGuard from 'src/components/GuestGuard';
import HomeView from 'src/views/pages/HomeView';

const routesConfig = [
  {
    exact: true,
    path: '/404',
    component: lazy(() => import('src/views/pages/Error404View'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/login',
    component: lazy(() => import('src/views/auth/LoginView'))
  },
  {
    exact: true,
    path: '/login-unprotected',
    component: lazy(() => import('src/views/auth/LoginView'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/register',
    component: lazy(() => import('src/views/auth/RegisterView'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/registersuccess',
    component: lazy(() => import('src/views/auth/RegisterSucces'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/success',
    component: lazy(() => import('src/views/auth/RegisterSucces'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/verifytoken/:token',
    component: lazy(() => import('src/views/auth/VerifyToken'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/resetpassword/:token',
    component: lazy(() => import('src/views/auth/VerifyToken'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/resetpassword',
    component: lazy(() => import('src/views/auth/ForgotPassword/PasswordReset'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/forgotpassword',
    component: lazy(() => import('src/views/auth/ForgotPassword'))
  },
  {
    path: '/app',
    guard: AuthGuard,
    layout: MainLayout,
    routes: [
      {
        exact: true,
        path: '/app',
        component: () => <Redirect to="/app/recharges/cubacel" />
      },
      {
        exact: true,
        path: '/app/account',
        component: lazy(() => import('src/views/pages/AccountView'))
      },
      {
        exact: true,
        path: '/app/account/testimonials',
        component: lazy(() => import('src/views/pages/AccountView'))
      },
      {
        exact: true,
        path: '/app/recharges/cubacel',
        component: lazy(() => import('src/views/pages/RechargeCubacelView'))
      },
      {
        exact: true,
        path: '/app/recharges/nauta',
        component: lazy(() => import('src/views/pages/RechargeNautaView'))
      },
      {
        exact: true,
        path: '/app/history',
        component: lazy(() => import('src/views/pages/HistoryView'))
      },
      {
        component: () => <Redirect to="/404" />
      }
    ]
  },
  {
    path: '*',
    layout: MainLayout,
    routes: [
      {
        exact: true,
        path: '/',
        component: HomeView
      },
      {
        exact: true,
        path: '/about',
        component: lazy(() => import('src/views/pages/AboutView'))
      },
      {
        exact: true,
        path: '/docs/:title',
        component: lazy(() => import('src/views/pages/InformationView'))
      },
      {
        exact: true,
        path: '/contact-us',
        component: lazy(() => import('src/views/pages/ContactUsView'))
      },
      {
        exact: true,
        path: '/terms-conditions',
        component: lazy(() => import('src/views/pages/TermsAndConditionsView'))
      },
      {
        exact: true,
        path: '/privacy',
        component: lazy(() => import('src/views/pages/PrivacyView'))
      },
      {
        exact: true,
        path: '/refund',
        component: lazy(() => import('src/views/pages/RefundView'))
      },
      {
        component: () => <Redirect to="/404" />
      }
    ]
  }
];

const renderRoutes = (routes) =>
  routes ? (
    <Suspense fallback={<LoadingScreen />}>
      <Switch>
        {routes.map((route, i) => {
          const Guard = route.guard || Fragment;
          const Layout = route.layout || Fragment;
          const Component = route.component;

          return (
            <Route
              key={i}
              path={route.path}
              exact={route.exact}
              render={(props) => (
                <Guard>
                  <Layout>
                    {route.routes ? (
                      renderRoutes(route.routes)
                    ) : (
                      <Component {...props} />
                    )}
                  </Layout>
                </Guard>
              )}
            />
          );
        })}
      </Switch>
    </Suspense>
  ) : null;

function Routes() {
  return renderRoutes(routesConfig);
}

export default Routes;
